<template>
  <section class="why-choose-section">
    <div class="container">
      <div class="title-wrapper">
        <h2 class="section-title">WHY CHOOSE US ?</h2>
      </div>

      <div class="features-grid">
        <div class="feature-card" 
             @touchstart="activeCard = 1" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 1 }">
          <h3 class="card-title">EXPERTISE AND EXPERIENCE</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2a10 10 0 1 0 10 10H12V2z"></path>
              <path d="M12 2v10h10"></path>
            </svg>
          </div>
          <p class="card-desc">
            Decades of specialized experience in steel and aluminum engineering components ensuring precision and quality.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 2" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 2 }">
          <h3 class="card-title">ADVANCED TECHNOLOGY</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
          </div>
          <p class="card-desc">
            Utilization of cutting-edge manufacturing technologies for superior performance and durability.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 3" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 3 }">
          <h3 class="card-title">QUALITY ASSURANCE</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <p class="card-desc">
            Rigorous quality control processes guaranteeing reliable, high-grade products every time.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 4" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 4 }">
          <h3 class="card-title">CUSTOMIZED SOLUTIONS</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <circle cx="15.5" cy="15.5" r="1.5"></circle>
            </svg>
          </div>
          <p class="card-desc">
            Tailored manufacturing services designed to meet your unique project requirements.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 5" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 5 }">
          <h3 class="card-title">TIMELY DELIVERY</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <p class="card-desc">
            Commitment to on-time delivery without compromising on quality.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 6" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 6 }">
          <h3 class="card-title">CUSTOMER CENTRIC APPROACH</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <p class="card-desc">
            Dedicated support and transparent communication throughout the project lifecycle.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 7" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 7 }">
          <h3 class="card-title">SUSTAINABILITY FOCUS</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
              <path d="M7.9 10.1l.6 6.6 4.2-2.5 2.6-2.4-7.4-1.7z"></path>
            </svg>
          </div>
          <p class="card-desc">
            Environmentally responsible practices minimizing waste and energy consumption.
          </p>
        </div>

        <div class="feature-card"
             @touchstart="activeCard = 8" 
             @touchend="activeCard = null"
             :class="{ 'is-touched': activeCard === 8 }">
          <h3 class="card-title">DIVERSE METAL EXPERTISE</h3>
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>
              <line x1="16" y1="8" x2="2" y2="22"></line>
              <line x1="17.5" y1="15" x2="9" y2="15"></line>
            </svg>
          </div>
          <p class="card-desc">
            Proficient in working with multiple metals including Aluminum, Brass, Copper, Steel, Stainless Steel, Zinc and more to meet a wide range of industrial needs.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhyChoose',
  data() {
    return {
      activeCard: null // 用于记录移动端当前按下的卡片
    };
  }
};
</script>

<style scoped>
.why-choose-section {
  padding: 80px 0;
  background-color: #ffffff;
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-wrapper {
  text-align: center;
  margin-bottom: 60px;
  width: 100%;
}

.section-title {
  font-size: 72px;
  font-weight: 600;
  color: #111111;
  text-transform: uppercase;
  letter-spacing: -1px;
  margin: 0;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  width: 100%;
}

/* 卡片基础样式 */
.feature-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 20px;
  padding: 36px 28px;
  text-align: center;
  transition: all 0.4s ease;
  backface-visibility: hidden;
  transform: translateZ(0);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 仅在支持鼠标悬停的设备上应用 hover 效果，解决移动端“粘滞”Bug */
@media (hover: hover) {
  .feature-card:hover {
    border-color: #16bc9c;
    box-shadow: 0 8px 24px rgba(22, 188, 156, 0.08);
    transform: translateY(-3px);
  }
  .feature-card:hover .card-icon {
    transform: rotateY(360deg) rotate(360deg);
  }
}

/* 移动端专属的触碰动画类 */
.feature-card.is-touched {
  border-color: #16bc9c;
  box-shadow: 0 8px 24px rgba(22, 188, 156, 0.08);
  transform: scale(0.98); /* 点击时微微缩小，触感更好 */
}
.feature-card.is-touched .card-icon {
  transform: rotateY(360deg) rotate(360deg);
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #16bc9c;
  margin: 0 0 24px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  height: 40px; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  color: #16bc9c;
  transition: transform 0.7s cubic-bezier(0.25, 0.8, 0.25, 1);
  transform-style: preserve-3d;
}

.card-desc {
  font-size: 15px;
  color: #555555;
  line-height: 1.6;
  font-weight: 600;
  text-align: center;
  margin: 0;
}

/* ========================================================
   响应式调整区域
   ======================================================== */

/* ★ 关键修复：仅在 1025px - 1200px（4列太挤时）缩小内容 */
@media (min-width: 1025px) and (max-width: 1200px) {
  .section-title {
    font-size: 56px; 
  }
  .feature-card {
    padding: 30px 16px; /* 减小内边距 */
  }
  .card-title {
    font-size: 13px; /* 标题进一步缩小防止折行 */
    height: 36px;
    margin: 0 0 16px;
  }
  .card-icon {
    width: 40px;  
    height: 40px;
    margin: 0 auto 16px;
  }
  .card-desc {
    font-size: 13px; 
  }
}

/* ★ 1024px 及以下，变成2列。由于空间变大了，恢复正常大小！ */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .section-title {
    font-size: 48px;
  }
  /* 这里不需要写卡片的字号样式，因为它会自动回退到最上面的默认 16px 样式 */
}

/* 手机端 */
@media (max-width: 576px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  .section-title {
    font-size: 32px;
  }
  .why-choose-section {
    padding: 40px 0;
  }
}
</style>